import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const FlnTagMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const [tagName, setTagName] = useState('')
    const [tagDescription, setTagDescription] = useState('')
    const [tagDetails, setTagDetails] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);

    const [nameSort, setNameSort] = useState(null);
    const [descriptionSort, setDescriptionSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["tagName", "tagDescription", "createdAt"];

    const [error, setError] = useState('')
    const [errord, setErrord] = useState('')
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setTagDetails(await searchArray("A", '/get-tag-master', searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        const apiUrl = `/fln-tag`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTagDetails(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, [refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(tagDetails, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(tagDetails.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > tagDetails.length) {
            endIndex = tagDetails.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(tagDetails.slice(startIndex, endIndex));
    }, [tagDetails, currPage, itemsPerPage]);

    useEffect(() => {
        if (tagName !== '') {
            setError('')

        }
        if (tagDescription !== '') {
            setErrord('')
        }
    }, [tagName, tagDescription])

    const addCourse = () => {
        const apiUrl = `/fln-tag`;
        if (tagName !== '' && tagDescription !== '') {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, {
                tagName,
                tagDescription
            })
                .then(response => {
                    setTagDetails((prevCourses) => [...prevCourses, response.data.result]);
                    setTagName('')
                    setTagDescription('')
                    setRefresh(!refresh);
                    setSaveId(response.data.result.id);
                    setNameSort(null);
                    setDescriptionSort(null);
                    setDateSort(null);
                    setSearchValue(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            if (tagName == '') {
                setError("This field is required.")
            }
            if (tagDescription == '') {
                setErrord("This field is required.")
            }
        }
    }

    const deleteCourse = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-fln-tag-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, tagDetails.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateCourse = () => {
        setLoading(true);
        const apiUrl = `/edit-tag-master?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, {
            tagName,
            tagDescription
        })
            .then(response => {
                setTagDetails((prevCourses) => [...prevCourses].map((course) => course.id == editId ? response.data.result : course));
                setEditId(null);
                setTagName('')
                setTagDescription('')
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setDateSort(null);
            setDescriptionSort(null);
        }
    }, [nameSort])

    useEffect(() => {
        if (descriptionSort == true || descriptionSort == false) {
            setNameSort(null);
            setDateSort(null);
        }
    }, [descriptionSort])

    useEffect(() => {
        if (dateSort == true || dateSort == false) {
            setNameSort(null);
            setDescriptionSort(null);
        }
    }, [dateSort])

    const handleInputReset = () => {
        setTagName('');
        setTagDescription('');
        setEditId('');
        setNameSort(null);
        setDateSort(null);
        setDescriptionSort(null);
        setError("")
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>FLN Tag Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-tag"></i>FLN Tag Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-12 board_name mt-3 mb-3">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter FLN Tag Name</label>
                                                    <input type="text" className="form-control" id="gradeName" value={tagName} onChange={(e) => setTagName(e.target.value.toUpperCase())} />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>


                                                <div className="col-md-12 board_name">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter FLN Tag Description</label>
                                                    <input type="text" className="form-control" id="gradeName2" name='2' value={tagDescription} onChange={(e) => setTagDescription(e.target.value.toUpperCase())} />
                                                    {errord && <p style={{ color: 'red' }}>{errord}</p>}
                                                </div>

                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addCourse}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateCourse} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setTagDetails} setCurrPage={setCurrPage} sortingPath={"tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Tag Description
                                                                            <SortIcon sortState={descriptionSort} setSortState={setDescriptionSort} setData={setTagDetails} setCurrPage={setCurrPage} sortingPath={"tagDescription"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setTagDetails} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((course, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{course.tagName}</td>
                                                                                        <td>{course.tagDescription}</td>
                                                                                        <td>{course.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button disabled className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTagName(course.tagName);
                                                                                                setTagDescription(course.tagDescription);
                                                                                                setEditId(course.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled /*disabled={editId === course.id}*/ onClick={() => deleteCourse(course.id)}> <i class="fa-light fa-trash-can"></i></button>

                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Tag Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={tagDetails.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default FlnTagMaster;